export default {
  tags: [],
  pagination: {},
  tag: {}
}
